import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronDown = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props} data-testid="chevron-down">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.1182 12.8685C35.1182 13.0605 35.0447 13.2525 34.8992 13.3995L20.6493 27.6613C20.5083 27.8023 20.3178 27.8818 20.1184 27.8818C19.9189 27.8818 19.7284 27.8023 19.5874 27.6613L5.33754 13.3995C5.04504 13.1055 5.04504 12.6315 5.33754 12.3375C5.63153 12.045 6.10553 12.045 6.39952 12.3375L20.1184 26.0714L33.8372 12.3375C34.1312 12.045 34.6052 12.045 34.8992 12.3375C35.0447 12.4845 35.1182 12.6765 35.1182 12.8685Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChevronDown
